import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NotificationService } from 'src/@core/services/notification.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material';
import { EmploymentService } from 'src/@core/services/employment/employment.service';
import { Router } from '@angular/router';
import { JobPipe } from 'src/@core/pipes/data/job.pipe';
import { WorkLogService } from 'src/@core/services/employment/worklog.service';
import { AssignJobAdminComponent } from 'src/app/modules/employment/assign-job-admin/assign-job-admin.component';
import { AssignAdminDialogComponent } from 'src/app/modules/employment/assign-admin-dialog/assign-admin-dialog.component';
import { CancelEmployementComponent } from 'src/app/modules/employment/employment/cancel-employement/cancel-employement.component';
import { AddChampComponent } from '../add-champ/add-champ.component';
import { API_WORK_ORDER } from 'src/@core/services/util/api.endpoints';
import { HttpClient } from '@angular/common/http';
import { entityTypes, permissions } from 'src/app/shared/helpers/roles-permissions';

@Component({
  selector: 'hour4u-admin-work-order-burger-menu',
  templateUrl: './work-order-burger-menu.component.html',
  styleUrls: ['./work-order-burger-menu.component.scss']
})
export class WorkOrderBurgerMenuComponent implements OnInit {
  @Input() row: any;
  @Input() status: any;
  @Input() roles: any;
  entityTypes = entityTypes;
  permissions = permissions;
  @Output() dataRefresh = new EventEmitter();

  copyTitleInvoiceShare: string = 'Share Invoice Payment';
  copiedShareInvoice: boolean = false;
  screenWidth = window.innerWidth;

  constructor(
    private notify: NotificationService,
    private dialog: MatDialog,
    private service: EmploymentService,
    private router: Router,
    private jobPipe: JobPipe,
    private workLogService: WorkLogService,
    private http: HttpClient
  ) { }

  ngOnInit() {
  }

  // View employement
  goToView(row) {
    // if (row.status == 'Pending') {
    this.router.navigateByUrl('/enterprise-admin/view-work-order/' + row.id);
    // } else {
    //   this.router.navigateByUrl('/employment/job-applications/all/' + row.id);
    // }
  }

  // UPDATE EMPLOYEMENT
  update(object: any): void {
    this.router.navigate(['/enterprise-admin/create-work-order'], { queryParams: { mode: 'edit', employmentId: object.id } });

  }

  // CLONE EMPLOYEMENT/SHIFT
  clone(object: any): void {
    this.router.navigate(['/enterprise-admin/create-work-order'], { queryParams: { mode: 'clone', employmentId: object.id } });
  }

  // SHIFT DELETE
  delete(id: string) {
    this.notify.showMessage('Deleting employment #' + id, 3000);
    this.service.delete(id).toPromise()
      .then(() => {
        this.notify.showMessage('Employment deleted', 3000);
      }).catch(error => {
        this.notify.showMessage('Could not delete employment ', 3000);
      }).finally(() => {
        this.dataRefresh.emit();
      });
  }

  // ASSIGN ADMIN DIALOG
  assignJobAdmin(data): void {
    // const employmentAdmin = new EmploymentAdministration();
    // employmentAdmin.employmentId = id;
    const dialogRef = this.dialog.open(AssignJobAdminComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  // ASSIGN JOB SUPERVISOR DIALOG
  assignJobSupervisor(row): void {
    // const employmentAdmin = new EmploymentAdministration();
    // employmentAdmin.employmentId = id;
    const dialogRef = this.dialog.open(AssignAdminDialogComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: row
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  // REDIRECT TO JOBSEEKER LIST PAGE
  redirectToJobSeekerList(id, date) {
    this.router.navigate(['/employment/active/' + id, {
      date: date
    }])
  }

  // GO TO PAYMENT REQUEST PAGE OF EMPLOYER ADMIN
  async getPaymentReqs(data) {
    let jobt: string;
    await this.jobPipe.transform(data.jobId).then(v => jobt = v);
    this.router.navigate(['/employment/payment/' + data.id], {
      queryParams: {
        jobTitle: jobt,
        employmentTitle: data.employmentTitle,
        employerId: data.employerId,
        date: data.dates[0].date
      }
    });
  }

  // Show view payment reqs to super admin
  async showAllPaymentReqs(data: any) {
    let jobt: string;
    await this.jobPipe.transform(data.jobId).then(v => jobt = v);
    this.router.navigate(['/employment/job-seeker-payment/' + data.id], {
      queryParams: {
        jobTitle: jobt,
        employmentTitle: data.employmentTitle,
        employerId: data.employerId,
        date: data.dates[0].date
      }
    });
  }

  // SEND WORKLOG PAGE OPEN
  async sendWorkLog(job) {
    let jobt: string;
    await this.jobPipe.transform(job.jobId).then(v => jobt = v);
    this.router.navigate(['/employment/work-log/' + job.id], {
      queryParams: {
        jobTitle: jobt,
        employmentTitle: job.employmentTitle,
        employerId: job.employerId,
        date: job.dates[0].date
      }
    });
  }

  // DOWNLOAD WORKLOG
  async downloadWorkLog(id) {
    const blob = await this.workLogService.getWorklogAttPay(id)
      .catch(error => {
        this.notify.showMessage('Unable to download work log.', 2000);
      });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'work_log_' + id + '.xlsx';
    link.click();

    window.URL.revokeObjectURL(url);
  }

  // cancel employemnet
  cancelEmployement(employment: any) {
    console.log(employment)
    const dialogRef = this.dialog.open(CancelEmployementComponent, {
      width: '700px',
      data: employment,
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.dataRefresh.emit();
        }
      }
    );
  }

  // SHARE INVOICE PAYMENT
  shareInvoicePayment(row) {
    let copyUrl = null;
    this.copiedShareInvoice = true;
    this.copyTitleInvoiceShare = 'Copied to your clipboard!';
    if (environment.api_url == 'https://devapi.hour4u.com') {
      copyUrl = 'https://dev.workorbits.com/invoice-pay/' + row.id
    }
    if (environment.api_url == 'https://api.hour4u.com') {
      copyUrl = 'https://workorbits.com/invoice-pay/' + row.id
    }

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.notify.showMessage('Link copied!', 3000)
    setTimeout(() => {
      this.copiedShareInvoice = false;
      this.copyTitleInvoiceShare = 'Share Invoice Payment';
    }, 7000);
  }

  // SHARE PROOF OF WORK
  async shareProofOfWork(row) {
    const blob = await this.workLogService.getProofOfWork(row.id)
      .catch(error => {
        this.notify.showMessage('Unable to download work log.', 2000);
      });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'proof_of_work_' + row.id + '.xlsx';
    link.click();

    window.URL.revokeObjectURL(url);
  }

  async shareProofOfWorkinPPT(row) {
    try {
      // Hit the API without downloading the PPT
      await this.workLogService.getProofOfWorkinPPT(row.id);

      // Show the success toast message
      this.notify.showMessage(
        'Proof of work requested successfully',
        50000,
        'assets/tick-circle.svg',
        'You will receive an email in a few minutes when it is ready to download.'
      );
    } catch (error) {
      this.notify.showMessage('Unable to process the request.', 2000);
    }
  }


  deleteWorkOrder(row) {
    const workOrderId = row.id; // Assuming the work order ID is stored in the 'id' property of the row object
    const deleteUrl = `${API_WORK_ORDER}/${workOrderId}`; // Construct the URL for deleting the work order
    this.notify.showMessage('Deleting work order #' + workOrderId, 3000);

    this.http.delete(deleteUrl) // Send a DELETE request to the API_WORK_ORDER endpoint
      .subscribe(
        () => {
          this.notify.showMessage('Work order deleted', 3000);
          this.dataRefresh.emit(); // Emit the dataRefresh event to notify the parent component to refresh its data
        },
        error => {
          this.notify.showMessage('Could not delete work order', 3000);
        }
      );
  }

  // Add Champ
  addChamp(object?: any): void {
    let data = null;
    data = Object.assign({}, object);
    const dialogRef = this.dialog.open(AddChampComponent, {
      width: '700px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }
}
